import React, { useRef, useEffect, useState } from 'react';
import './CustomDropdown.css';
import arrow from './arrow.svg';

export default function CustomDropdown({ options = [], value, onChange, placeholder, fullWidth }) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => setIsOpen((prev) => !prev);

    const handleSelect = (option) => {
        setIsOpen(false);
        if (onChange) onChange(option.value);
    };

    const selectedOption = options.find((opt) => opt.value === value);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="dropdowncust" ref={dropdownRef} style={{width: fullWidth ? '100%' : '20%'}}>
            <div className="dropdown-header" onClick={toggleDropdown}>
                {selectedOption?.label || placeholder}
                {/*<span className={`arrow ${isOpen ? 'open' : ''}`}>▼</span>*/}
                <img className={`arrow ${isOpen ? 'open' : ''}`} src={arrow}/>

            </div>
            {isOpen && (
                <ul className="dropdown-list">
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className="dropdown-item"
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}